export default "__VITE_ASSET__suLRYJc7__";